import { Center, Heading, useToast } from '@chakra-ui/react';
import { CustomButton } from '@Modules/core/components';
import GenericFormUI from '@Shared/components/form/GenericFormUI';
import { useMutation, useQuery } from '@tanstack/react-query';
import transactionsFormMeta from './TransactionsFormMeta';

const acquirerTransactionsMeta = {...transactionsFormMeta};

delete acquirerTransactionsMeta.emitterBank;

const AcquirerTransactionsFormHandler = () => {
    
  const toast = useToast();

  //   Initialize react Query to GET Data
  const queryKey = ["AcquirerTransactions"];
  const {
    data,
    isLoading,
  } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
        // TODO: Replace this by your fetcher function
        return new Promise(function(resolve) {
            setTimeout(() => resolve("data"), 500);
        });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title: "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  
  const { isLoading: isSubmitting } = useMutation( async() => {}, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      toast({
        position: 'top-right',
        title: "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    /*try {
         await mutateAsync();
     } catch (error) {
         console.log(error);
     }*/
  };

  return (
    <>
              
        <GenericFormUI meta={acquirerTransactionsMeta} onSubmit={onSubmit} isLoading={isLoading} isSubmitting={isSubmitting} submitBtn={<Center my={8}><CustomButton isLoading={isLoading} isSubmitting={isSubmitting} w={'50%'}>Génération Rapport</CustomButton></Center>} />
    
    </>
  );
};

export default AcquirerTransactionsFormHandler;
